var storefrontApp = angular.module('storefrontApp');

storefrontApp.controller('productGridItemController', ['$rootScope', '$scope', '$window', 'catalogService', 'cartService',
    function ($rootScope, $scope, $window, catalogService, cartService) {

        var vm = this;

        vm.isBusy = false;
        vm.isInCart = false;
        vm.isRecurring = false;
        vm.quantity = 1;
        vm.intervalCount = 30;
        vm.interval = 'Days';
        vm.errorMessage = null;
        vm.isImpersonating = false;

        vm.intervalOptions = [30, 45, 60, 90];
        vm.quantityOptions = [1,2,3,4,5,6,7,8,9,10];

        vm.initData = function (product, isImpersonating) {
            vm.productId = product.id;
            vm.isImpersonating = isImpersonating;

            if (product.cartLineItem) {
                vm.isInCart = true;
                vm.quantityOptions.unshift(0);
                vm.quantity = product.cartLineItem.quantity;
                vm.isRecurring = product.cartLineItem.isRecurring;

                if (product.cartLineItem.isRecurring && product.cartLineItem.paymentPlan) {
                    vm.interval = product.cartLineItem.paymentPlan.interval;
                    vm.intervalCount = product.cartLineItem.paymentPlan.intervalCount;
                }
            }
            else if (!isImpersonating) {
                vm.isRecurring = true;
            }
        };

        vm.submit = function () {
            vm.isBusy = true;
            vm.errorMessage = null;
            
            var item = {
                productId: vm.productId,
                quantity: vm.quantity,
                isRecurring: vm.isRecurring,
                interval: vm.interval,
                intervalCount: vm.intervalCount
            };

            cartService.addOrUpdateItem(item).then(function (response) {
                if (vm.isImpersonating) {
                    $window.location.reload();
                }
                else {
                    $window.location.href = "/cart";
                }
            }, function (response) {
                vm.isBusy = false;
                vm.errorMessage = 'Error processing request';
            });

        };

        function initialize() {

        }

        initialize();
    }]);